/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useToggle } from 'ahooks';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSwiper, useSwiperSlide } from 'swiper/react';

interface Props {
  poster: string;
  posterFallback: string;
  video?: string;
  isVideoDisabled?: boolean;
}

const variants = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
};

export default function Item({ poster, posterFallback, video, isVideoDisabled = false }: Props) {
  const swiperSlide = useSwiperSlide();
  const swiper = useSwiper();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [showVideo, { setLeft, setRight }] = useToggle(false);
  const [imgHeight, setImgHeight] = useState(0);

  const handleImgLoad: React.ReactEventHandler<HTMLImageElement> = (event) => {
    // @ts-ignore
    const { height } = event.target;
    setImgHeight(height);
  };

  useEffect(() => {
    if (!showVideo) {
      return;
    }

    if (videoRef.current) {
      videoRef.current.onended = () => {
        setLeft();
      };
    }
  }, [setLeft, showVideo]);

  useEffect(() => {
    if (swiperSlide.isActive) {
      return;
    }
    setLeft();
  }, [swiperSlide.isActive, setLeft]);

  useEffect(() => {
    if (!showVideo) {
      swiper?.autoplay?.start();
    } else {
      swiper?.autoplay?.stop();
    }
  }, [showVideo, swiper?.autoplay]);

  const renderVideo = () => (
    <motion.video
      ref={videoRef}
      className="mx-auto w-100 d-block"
      src={video}
      style={{ height: imgHeight }}
      autoPlay
      muted={false}
      playsInline
      controls={false}
      variants={variants}
      initial="initial"
      animate="animate"
    />
  );

  const renderImage = useMemo(
    () => (
      <picture>
        <source srcSet={poster} type="image/webp" />
        {posterFallback && <source srcSet={posterFallback} type="image/png" />}
        <motion.img
          className="mx-auto img-fluid d-block"
          src={poster}
          variants={variants}
          initial="initial"
          animate="animate"
          onLoad={handleImgLoad}
          style={{ minHeight: 150 }}
        />
      </picture>
    ),
    [poster]
  );

  return (
    <AnimatePresence>
      <div onClick={setRight}>{!isVideoDisabled && showVideo && video ? renderVideo() : renderImage}</div>
    </AnimatePresence>
  );
}
